// extracted by mini-css-extract-plugin
export default {"Spinner":"yLcMKjZY","spin":"rRBntL5P"};